import Vue from 'vue'
import ShowForm from './ShowForm'
import EditForm from './EditForm'

Vue.component('DriverShowForm', ShowForm)
Vue.component('DriverEditForm', EditForm)
